import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  standalone: false
})
export class CustomToastComponent {
  @Input() message: string = '';
  @Input() show: boolean = false;
  @Input() type: 'success' | 'info' | 'error' = 'success';
  @Output() hideToast = new EventEmitter<void>();
  
  @ViewChild('toastElement', { static: false }) toastElement!: ElementRef;
  
  private startX: number = 0;
  private currentX: number = 0;
  private isDragging: boolean = false;
  private initialTransform: string = '';

  getIconName(): string {
    switch (this.type) {
      case 'info':
        return 'alert';
      case 'error':
        return 'close';
      case 'success':
      default:
        return 'checkmark';
    }
  }

  onTouchStart(event: TouchEvent): void {
    this.startX = event.touches[0].clientX;
    this.currentX = this.startX;
    this.isDragging = true;
    this.initialTransform = this.toastElement.nativeElement.style.transform || '';
  }

  onTouchMove(event: TouchEvent): void {
    if (!this.isDragging) return;
    
    this.currentX = event.touches[0].clientX;
    const deltaX = this.currentX - this.startX;
    
    // Solo permitir deslizar hacia la izquierda
    if (deltaX < 0) {
      const translateX = Math.max(deltaX, -300); // Limitar el deslizamiento
      this.toastElement.nativeElement.style.transform = `translateX(${translateX}px)`;
      this.toastElement.nativeElement.style.opacity = `${1 + (deltaX / 300)}`;
    }
  }

  onTouchEnd(event: TouchEvent): void {
    if (!this.isDragging) return;
    
    const deltaX = this.currentX - this.startX;
    const threshold = -100; // Umbral para ocultar el toast
    
    if (deltaX < threshold) {
      // Ocultar el toast
      this.toastElement.nativeElement.style.transform = 'translateX(-100%)';
      this.toastElement.nativeElement.style.opacity = '0';
      setTimeout(() => {
        this.hideToast.emit();
      }, 300);
    } else {
      // Restaurar posición original
      this.toastElement.nativeElement.style.transform = this.initialTransform;
      this.toastElement.nativeElement.style.opacity = '1';
    }
    
    this.isDragging = false;
  }
}
